import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";

export const formatLimit = (amount?: string | number): string =>
  amount ? formatMoney(Number(amount), "USD") : "—";
